<div class="breadcrumbGlobal">
    <a [routerLink]="['/mydashboard']">
        <mat-icon>home</mat-icon>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <a [routerLink]="['/subscription-account']" translate>SUBSCRIPTIONS_ACCOUNTS.SUBSCRIPTIONS_ACCOUNTS_MANAGEMENT</a>
    <mat-icon>chevron_right</mat-icon>
    <a [routerLink]="['/import-export-home']">{{ this.mng_impexp_title }}</a>
    <mat-icon>chevron_right</mat-icon>
    <span translate>IMPORT_EXPORT_SECTION.IMP_DATA</span>
</div>

<tb-header specificTitle="IMPORT_EXPORT_SECTION.IMP_DATA" [specificSubTitle]="this.subDescriSelected +' ('+ this.subKeySelected +')'"></tb-header>

<div class="contentGlobal">
    <div style="display: flex; flex-direction: row">
        <div style="width: 85%">
            <mat-stepper [orientation]="(stepperOrientation | async)!" #stepper [linear]="true">
                <ng-template matStepperIcon="edit" let-index="index">
                    {{ index + 1 }}
                </ng-template>
                <mat-step name="1-configuration" [completed]="favoriteImport !== undefined">
                    <div class="containerStepper">
                        <ng-template matStepLabel><span translate>IMPORT_EXPORT_SECTION.CHOOSE_CONFIGURATION</span></ng-template>
                        <mat-card [hidden]="showProcessStarted" class="fuse-card-grid">
                            <mat-card-title translate><span translate>IMPORT_EXPORT_SECTION.CHOOSE_DATA_TO_IMPORT</span></mat-card-title>
                            <mat-card-content style="padding: 1.5rem">
                                <form>
                                    <mat-radio-group class="radio-group" (change)="importTypeRadioGroupSelectionChange()" #importTypeRadioGroup [(ngModel)]="favoriteImport" name="importTypeRadioGroup">
                                        <mat-radio-button class="radio-button" value="default" checked #default>
                                            <span translate class="text-bold">IMPORT_EXPORT_SECTION.DEFAULT_DATA</span>&nbsp;-&nbsp;<span translate>IMPORT_EXPORT_SECTION.CHOOSE_DATA_TO_IMPORT_TOOLTIP_1</span
                                            >
                                        </mat-radio-button>
                                        <div *ngIf="this.showCountrySectionDEFAULT" style="display: flex; margin-left: 1.8rem; flex-direction: column">
                                          <div  style="display: flex; padding-right: 1.8rem;">
                                            <div>
                                                <mat-form-field appearance="outline">
                                                    <mat-label translate>USER_FORM.COUNTRY</mat-label>
                                                    <mat-select
                                                        placeholder="Country code"
                                                        name="selectedCountry"
                                                        [(value)]="selectedCountry.value"
                                                        (selectionChange)="selectedCountryChange($event)"
                                                        required
                                                    >
                                                        <mat-option *ngFor="let country of countries" [value]="country.value">
                                                            {{ country.name }}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field appearance="outline">
                                                    <mat-label translate>L_CONFIGURATION</mat-label>
                                                    <mat-select
                                                        placeholder="Configuration"
                                                        name="selectedConfiguration"
                                                        [(value)]="selectedConfiguration.value"
                                                        (selectionChange)="selectedConfigurationChange($event)"
                                                        required
                                                    >
                                                        <mat-option
                                                            *ngFor="let configuration of configurations"
                                                            [value]="configuration.value"
                                                            required
                                                        >
                                                            {{ configuration.name }}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                          </div>
                                            <div style="padding-right: 1.8rem; padding-bottom: 1.8rem">

                                                <form>
                                                  <mat-slide-toggle name="ChosenFilesToImport" [(ngModel)]="selectFilesToImport" *ngIf="showSelectFilesToImport">
                                                    <span translate class="text-bold">IMPORT_EXPORT_SECTION.CHOSEN_FILES</span>&nbsp;-&nbsp;
                                                    <span translate>IMPORT_EXPORT_SECTION.CHOSEN_FILES_DESCRI</span>
                                                  </mat-slide-toggle>
                                                </form>

                                            </div>
                                          </div>
                                        <mat-radio-button class="radio-button" value="optionaldefault" #optionalDefault>
                                            <span translate class="text-bold">IMPORT_EXPORT_SECTION.ONLY_DEFAULT_OPTIONAL_DATA</span
                                            >&nbsp;-&nbsp;<span translate>IMPORT_EXPORT_SECTION.CHOOSE_DATA_TO_IMPORT_TOOLTIP_2</span>
                                        </mat-radio-button>
                                        <mat-radio-button class="radio-button" value="sample" #sample>
                                            <span translate class="text-bold">IMPORT_EXPORT_SECTION.SAMPLE_DATA</span>&nbsp;-&nbsp;
                                            <span translate>IMPORT_EXPORT_SECTION.CHOOSE_DATA_TO_IMPORT_TOOLTIP_3</span>
                                        </mat-radio-button>
                                        <div *ngIf="this.showCountrySectionSAMPLEDATA" style="display: flex; margin-left: 1.8rem">
                                            <div style="padding-right: 1.8rem; padding-bottom: 1.8rem">
                                                <mat-form-field appearance="outline">
                                                    <mat-label translate>USER_FORM.COUNTRY</mat-label>
                                                    <mat-select
                                                        placeholder="Country code"
                                                        name="selectedCountry"
                                                        [(value)]="selectedCountry.value"
                                                        (selectionChange)="selectedCountryChange($event)"
                                                        required
                                                    >
                                                        <mat-option *ngFor="let country of countries" [value]="country.value">
                                                            {{ country.name }}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field appearance="outline">
                                                    <mat-label translate>L_CONFIGURATION</mat-label>
                                                    <mat-select
                                                        placeholder="Configuration"
                                                        name="selectedConfiguration"
                                                        [(value)]="selectedConfiguration.value"
                                                        (selectionChange)="selectedConfigurationChange($event)"
                                                        required
                                                    >
                                                        <mat-option
                                                            *ngFor="let configuration of configurations"
                                                            [value]="configuration.value"
                                                            required
                                                        >
                                                            {{ configuration.name }}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <mat-radio-button class="radio-button" value="custom" #custom>
                                            <span translate class="text-bold">IMPORT_EXPORT_SECTION.UPLOAD_FILE</span>&nbsp;-&nbsp;
                                            <span translate>IMPORT_EXPORT_SECTION.CHOOSE_DATA_TO_IMPORT_TOOLTIP_4</span>
                                        </mat-radio-button>
                                        <div *ngIf="favoriteImport === 'custom'" style="display: flex; margin-left: 1.8rem">
                                            <div class="row" style="margin-bottom: 15px">
                                                <input
                                                    type="file"
                                                    #file
                                                    placeholder="Choose file"
                                                    (change)="uploadFiles(file.files)"
                                                    style="display: none"
                                                    accept=".zip"
                                                />
                                                <button
                                                    mat-flat-button
                                                    color="primary"
                                                    *ngIf="uploadMessage === undefined"
                                                    (click)="file.click()"
                                                    class="button-icon-text"
                                                >
                                                    <mat-icon>add</mat-icon>
                                                    <span translate>COMMONS.UPLOAD_FILE</span>
                                            </button>
                                            <div class="message-box info" *ngIf="uploadMessage !== undefined">
                                                <span class="upload">
                                                        {{ uploadMessage }}
                                                        <button
                                                            matTooltip="{{ 'remove file' | translate }}"
                                                            matTooltipClass="tooltip-layout"
                                                            mat-icon-button
                                                            class="trash"
                                                            (click)="removeFiles()"
                                                        >
                                                            <mat-icon> delete_outline </mat-icon>
                                                        </button>
                                                    </span>
                                            </div>
                    </div>
        </div>
        </mat-radio-group>
        </form>
        </mat-card-content>
        </mat-card>
        <div class="text-center">
            <button mat-stroked-button color="secondary" matStepperPrevious (click)="clean()">
              <span translate>COMMONS.BACK</span>
            </button>
            <button mat-stroked-button color="secondary" matStepperNext *ngIf="!selectFilesToImport"
                      [disabled]="favoriteImport === undefined ||
                      (favoriteImport === 'custom' && (countFilesToImport === 0 || importKey === '')) ||
                      (favoriteImport === 'default' && favoriteConfigurationOption === '') ||
                      (favoriteImport === 'sample' && favoriteConfigurationOption === '')">
              <span translate>COMMONS.NEXT</span>
            </button>
            <button mat-stroked-button color="secondary" matStepperNext *ngIf="selectFilesToImport"
                      [disabled]="favoriteImport === undefined ||
                      (favoriteImport === 'custom' && (countFilesToImport === 0 || importKey === '')) ||
                      (favoriteImport === 'default' && favoriteConfigurationOption === '') ||
                      (favoriteImport === 'sample' && favoriteConfigurationOption === '')" (click)="loadFiles()">
              <span translate>COMMONS.NEXT</span>
            </button>
        </div>
    </div>
    </mat-step>

    <mat-step name="2-SelectFiles" [completed]="this.checklistSelection.selected.length > 0" *ngIf="selectFilesToImport">
      <div class="containerStepper">
          <ng-template matStepLabel><span translate>IMPORT_EXPORT_SECTION.CHOSEN_FILES</span> </ng-template>
          <mat-card class="fuse-card-grid" [hidden]="showProcessStarted">
              <mat-card-title translate><span translate>IMPORT_EXPORT_SECTION.CHOSEN_FILES_DESCRI</span></mat-card-title>
              <mat-card-content style="padding: 1.5rem">
                  <div class="divCardActionRow">
                      <mat-slide-toggle name="CollapseExpandTree" (ngModel)="(favoriteTreeView)" (change)="collapseExpandChange($event)">
                          <span translate class="text-bold" *ngIf="!favoriteTreeView">IMPORT_EXPORT_SECTION.EXPAND_ALL</span>
                          <span translate class="text-bold" *ngIf="favoriteTreeView">IMPORT_EXPORT_SECTION.COLLAPSE_ALL</span>
                      </mat-slide-toggle>
                  </div>

                  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
                          <button mat-icon-button disabled></button>
                          <mat-checkbox class="checklist-leaf-node" [checked]="checklistSelection.isSelected(node)" (change)="todoLeafItemSelectionToggle(node)">{{ node.name }}</mat-checkbox>
                      </mat-tree-node>
                      <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
                          <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.item">
                              <mat-icon class="mat-icon-rtl-mirror">{{
                                  treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'
                              }}</mat-icon>
                          </button>
                          <mat-checkbox [checked]="descendantsAllSelected(node)" [indeterminate]="descendantsPartiallySelected(node)" (change)="todoItemSelectionToggle(node)">{{ node.name }}</mat-checkbox>
                      </mat-tree-node>
                  </mat-tree>
              </mat-card-content>
          </mat-card>
          <div class="text-center">
              <button mat-stroked-button color="secondary" matStepperPrevious><span translate>COMMONS.BACK</span></button>
              <button mat-stroked-button color="secondary" matStepperNext [disabled]="this.checklistSelection.selected.length === 0">
                  <span translate>COMMONS.NEXT</span>
              </button>
          </div>
      </div>
    </mat-step>

    <mat-step name="3-FilesList" [completed]="true" *ngIf="selectFilesToImport">
      <div class="containerStepper">
          <ng-template matStepLabel><span translate>IMPORT_EXPORT_SECTION.FILES_LIST_SUMMARY</span></ng-template>
          <mat-card class="fuse-card-grid">
              <mat-card-title translate><span translate>COMMONS.SELECTED_ITEMS</span></mat-card-title>
              <mat-card-content style="padding: 1.5rem">
                  <div *ngIf="showListFiles">
                      <span translate class="text-bold">IMPORT_EXPORT_SECTION.TOTAL_ELEM_SELECTED</span> : {{ getFilesList(3).length }}
                      <br />

                      <div id="selectedFileContainer" style="display: flex; flex-direction: row; flex-wrap: wrap" [ngClass]="{ 'line-clamp-10': !showMore }">
                          <div *ngFor="let file of getFilesList(3)" class="feature-layout">
                              <span translate style="white-space: pre">{{ file.name }}</span>
                          </div>
                      </div>
                      <div class="CollapseContentStyle text-right" style="margin-top: 2rem">
                          <button *ngIf="showMore" mat-button color="primary" (click)="hideDetails(selectedFileContainer)">
                              <span translate style="font-size: 1.1rem">COMMONS.COLLAPSE</span>
                          </button>
                          <button *ngIf="!showMore" mat-button color="primary" (click)="showDetails(selectedFileContainer)">
                              <span translate style="font-size: 1.1rem">COMMONS.READ_MORE </span>
                          </button>
                      </div>
                  </div>
                  <div *ngIf="!showListFiles">
                      <span translate>IMPORT_EXPORT_SECTION.ALL_FILES</span>
                  </div>
              </mat-card-content>
          </mat-card>

          <div class="text-center">
              <button mat-stroked-button color="secondary" matStepperPrevious><span translate>COMMONS.BACK</span></button>
              <button mat-stroked-button color="secondary" matStepperNext><span translate>COMMONS.NEXT</span></button>
          </div>
      </div>
    </mat-step>

    <mat-step name="4-ImportOptions" [completed]="true">
        <div class="containerStepper">
            <ng-template matStepLabel><span translate>IMPORT_EXPORT_SECTION.IMPORT_OPTIONS</span></ng-template>
            <mat-card class="fuse-card-grid">
                <mat-card-title translate><span translate>IMPORT_EXPORT_SECTION.DELETE_OPTIONS</span></mat-card-title>
                <mat-card-content style="padding-bottom: 1.5rem; padding-right: 1.5rem; padding-left: 1.5rem">
                    <form>
                        <mat-slide-toggle name="DeleteTableContext" [(ngModel)]="favoriteDeleteOption" name="deleteOpt">
                            <span translate class="text-bold">IMPORT_EXPORT_SECTION.DELETE_TABLE_CONTENTS</span
                                        >&nbsp;-&nbsp;<span translate>IMPORT_EXPORT_SECTION.DELETE_TABLE_CONTENTS_DESCRI</span>
                        </mat-slide-toggle>
                    </form>
                </mat-card-content>
                <mat-card-title *ngIf="!favoriteDeleteOption" translate><span translate>IMPORT_EXPORT_SECTION.OVERWRITE_OPTIONS</span></mat-card-title>
                <mat-card-content *ngIf="!favoriteDeleteOption" style="padding-bottom: 1.5rem; padding-right: 1.5rem; padding-left: 1.5rem">
                    <form>
                        <div style="margin-bottom: 0.8rem">
                            <span translate>IMPORT_EXPORT_SECTION.OVERWRITE_OPTIONS_CHOOSE</span>
                        </div>

                        <mat-radio-group class="radio-group" #importOptionsRadioGroup [(ngModel)]="favoriteOverwriteOption" name="overwrite-group">
                            <mat-radio-button class="radio-button" value="NoOverwriteRecord" name="NoOverwriteRecord" #noOverwriteRecord>
                                <span translate class="text-bold">IMPORT_EXPORT_SECTION.OVERWRITE_FIRST_OPTION</span
                                            >&nbsp;-&nbsp;<span translate>IMPORT_EXPORT_SECTION.OVERWRITE_FIRST_OPTION_DESCRI</span>
                            </mat-radio-button>
                            <mat-radio-button class="radio-button" value="OverwriteRecord" name="OverwriteRecord" checked #overwriteRecord>
                                <span translate class="text-bold">IMPORT_EXPORT_SECTION.OVERWRITE_SECOND_OPTION</span
                                            >&nbsp;-&nbsp;<span translate>IMPORT_EXPORT_SECTION.OVERWRITE_SECOND_OPTION_DESCRI</span>
                            </mat-radio-button>
                        </mat-radio-group>
                    </form>
                </mat-card-content>
            </mat-card>
            <div class="text-center">
                <button mat-stroked-button color="secondary" matStepperPrevious><span translate>COMMONS.BACK</span></button>
                <button mat-stroked-button color="secondary" matStepperNext><span translate>COMMONS.NEXT</span></button>
            </div>
        </div>
    </mat-step>

    <mat-step name="5-summary" [completed]="isStepComplete == true">
        <div class="containerStepper">
            <ng-template matStepLabel><span translate>COMMONS.SUMMARY</span></ng-template>
            <mat-card class="fuse-card-grid">
                <mat-card-title translate><span translate>COMMONS.SUMMARY_SETTINGS</span></mat-card-title>
                <mat-card-content style="padding: 1.5rem">
                    <div>
                        <table class="tableGenericStyle">
                            <tr>
                                <td><span class="text-bold" style="font-size: 1.08rem" translate>IMPORT_EXPORT_SECTION.CHOSEN_OPERATION</span></td>
                                <td><span style="font-size: 1.08rem" translate>IMPORT_EXPORT_SECTION.IMP_DATA</span></td>
                                <td><mat-icon class="icon-green-ok">check_circle</mat-icon></td>
                            </tr>
                            <tr>
                                <td>
                                  <span class="text-bold" style="font-size: 1.08rem" translate>IMPORT_EXPORT_SECTION.DATA_CONFIG_IMP</span>
                                </td>
                                <td style="font-size: 1.08rem">{{ getFavoriteImport(favoriteImport) }}</td>
                                <td><mat-icon class="icon-green-ok">check_circle</mat-icon></td>
                            </tr>
                            <tr>
                                <td>
                                  <span class="text-bold" style="font-size: 1.08rem" translate>IMPORT_EXPORT_SECTION.DELETE_CONTENT_IMP</span>
                                </td>
                                <td style="font-size: 1.08rem">{{ getYesOrNoOptionUnique(favoriteDeleteOption) | translate }}</td>
                                <td><mat-icon class="icon-green-ok">check_circle</mat-icon></td>
                            </tr>
                            <tr *ngIf="!favoriteDeleteOption">
                                <td style="font-size: 1.08rem">
                                    <span class="text-bold" style="font-size: 1.08rem" translate>IMPORT_EXPORT_SECTION.OVERWRITE_IMP</span>
                                </td>
                                <td style="font-size: 1.08rem">{{ getYesOrNoOptionUnique(favoriteOverwriteOption) | translate }}</td>
                                <td><mat-icon class="icon-green-ok">check_circle</mat-icon></td>
                            </tr>
                        </table>
                      </div>
                      <div class="message-box info">
                          {{ 'IMPORT_EXPORT_SECTION.IMPORT_SUMMARY_DESCR' | translate }}
                      </div>
                </mat-card-content>
              </mat-card>

              <div class="text-center">
                  <button mat-stroked-button color="secondary" matStepperPrevious><span translate>COMMONS.BACK</span></button>
                  <button mat-stroked-button color="secondary" matStepperNext (click)="doImportData()" [disabled]="subKeySelected === undefined">
                    <span translate>COMMONS.NEXT</span>
                  </button>
              </div>
        </div>
    </mat-step>

    <mat-step name="6-logs&results">
        <div class="containerStepper" #expConfig>
            <ng-template matStepLabel><span translate>IMPORT_EXPORT_SECTION.LOGS_RESULTS</span> </ng-template>
            <mat-card class="fuse-card-grid">
                <mat-card-content style="padding: 1.5rem" *ngIf="logs === undefined">
                    <div>
                        <h3 translate>IMPORT_EXPORT_SECTION.IMPORT_STARTED</h3>
                        <br />
                        <span translate>IMPORT_EXPORT_SECTION.GRAFANA_LOGS</span>

                        <button mat-icon-button color="primary" (click)="refreshFrame()">
                          <mat-icon>refresh</mat-icon>
                        </button>
                    </div>

                    <div id="grafanalogscontainer">
                        <div id="AppFrame4" class="codeContainer">
                            <p *ngFor="let log of grafanaLogsExtracted">
                                <span class="codeDate">{{ log[0] }}</span> &nbsp;&nbsp;{{ log[1] }}
                            </p>
                        </div>
                    </div>
                </mat-card-content>

                <mat-card-content style="padding: 1.5rem" *ngIf="logs === undefined">
                    <div>
                        <div class="message-box info" style="font-size: 1.1rem">
                            {{ 'IMPORT_EXPORT_SECTION.WAIT_END_EMAIL_IMPORT' | translate }}
                        </div>
                    </div>
                </mat-card-content>

                <mat-card-content style="padding: 1.5rem" *ngIf="logs !== undefined">
                    <h3 translate>COMMONS.FAILED_OPERATION</h3>
                    <div class="message-box error">{{ logs }}</div>
                </mat-card-content>
                <mat-card-actions align="center">
                    <button mat-button color="primary" (click)="stepper.reset(); clean()">
                                    <span translate> IMPORT_EXPORT_SECTION.GO_IMP_EXP_HOME</span>
                            <mat-icon>arrow_right_alt</mat-icon>
                            </button>
                </mat-card-actions>
            </mat-card>
        </div>
    </mat-step>
    </mat-stepper>

    <div *ngIf="loading">
        <tb-loading></tb-loading>
    </div>
</div>
</div>
</div>
